export const AD_VERTICAL_CODES = [
  "horse",
  "vehicle",
  "saddlery-and-more",
  "property"
] as const;

export type AdVertical = (typeof AD_VERTICAL_CODES)[number];

export interface AdVerticalOption {
  label: string;
  code: AdVertical;
}

const AD_VERTICAL_OPTIONS: AdVerticalOption[] = [
  {
    label: "Horses",
    code: "horse",
  },
  {
    label: "Trailer, Transporter or Tow Vehicle",
    code: "vehicle",
  },
  {
    label: "Saddlery, Tack and More",
    code: "saddlery-and-more",
  },
  {
    label: "Equine Property",
    code: "property",
  },
];

export default AD_VERTICAL_OPTIONS;
